"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PaneView = void 0;

var _react = _interopRequireDefault(require("react"));

require("./PaneView.css");

var _UseEffectOnce = _interopRequireDefault(require("../utils/UseEffectOnce"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

let startPaneRef;

const PaneView = _ref => {
  let {
    children,
    styleOverride,
    startOnPane = 0
  } = _ref;
  (0, _UseEffectOnce.default)(() => {
    setTimeout(() => startPaneRef && startPaneRef.scrollIntoView(), 1);
  });

  const renderPane = (content, i) => /*#__PURE__*/_react.default.createElement("div", {
    ref: node => {
      if (startOnPane === i) startPaneRef = node;
    },
    key: "pane".concat(i),
    className: "grevlingPaneViewPane"
  }, content);

  return /*#__PURE__*/_react.default.createElement("div", {
    className: "grevlingPaneView",
    style: styleOverride
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "grevlingPaneViewScrollyContent"
  }, Array.isArray(children) ? children.map(renderPane) : renderPane(children)));
};

exports.PaneView = PaneView;